import api from './api';

// =============================================================================
// USER ACTIVITY SERVICE
// =============================================================================
// Read-only service for the admin "User Activity" viewer. Fetches server-side
// user activity logs. No IndexedDB fallback — errors are thrown so the
// component can show an error banner.
// =============================================================================

// ---------------------------------------------------------------------------
// Action Types — machine key + human label + category
// ---------------------------------------------------------------------------
export const ACTION_TYPES = {
  USER_RATED_CLINIC: { key: 'USER_RATED_CLINIC', label: 'Rated Clinic', category: 'rating' },
  USER_RATED_SOS_EXPERIENCE: { key: 'USER_RATED_SOS_EXPERIENCE', label: 'Rated SOS Experience', category: 'rating' },
  USER_SUBMITTED_REPORT: { key: 'USER_SUBMITTED_REPORT', label: 'Submitted Report', category: 'report' },
  USER_REPORTED_POST: { key: 'USER_REPORTED_POST', label: 'Reported Post', category: 'report' },
  USER_REPORTED_STORY: { key: 'USER_REPORTED_STORY', label: 'Reported Story', category: 'report' },
  USER_REPORTED_USER: { key: 'USER_REPORTED_USER', label: 'Reported User', category: 'report' },
  USER_BLOCKED_USER: { key: 'USER_BLOCKED_USER', label: 'Blocked User', category: 'social' },
  USER_UNBLOCKED_USER: { key: 'USER_UNBLOCKED_USER', label: 'Unblocked User', category: 'social' },
  USER_SENT_BUDDY_REQUEST: { key: 'USER_SENT_BUDDY_REQUEST', label: 'Sent Buddy Request', category: 'social' },
  USER_CANCELLED_BUDDY_REQUEST: { key: 'USER_CANCELLED_BUDDY_REQUEST', label: 'Cancelled Buddy Request', category: 'social' },
  USER_ACCEPTED_BUDDY_REQUEST: { key: 'USER_ACCEPTED_BUDDY_REQUEST', label: 'Accepted Buddy Request', category: 'social' },
  USER_REJECTED_BUDDY_REQUEST: { key: 'USER_REJECTED_BUDDY_REQUEST', label: 'Rejected Buddy Request', category: 'social' },
  USER_REMOVED_BUDDY: { key: 'USER_REMOVED_BUDDY', label: 'Removed Buddy', category: 'social' },
};

// ---------------------------------------------------------------------------
// Retrieve logs (server-side only)
// ---------------------------------------------------------------------------
export async function getLogs(filters = {}) {
  const params = {};
  if (filters.dateFrom) params.date_from = filters.dateFrom;
  if (filters.dateTo) params.date_to = filters.dateTo;
  if (filters.actionType && filters.actionType.length) params.action_type = filters.actionType.join(',');
  if (filters.search) params.search = filters.search;
  if (filters.page) params.page = filters.page;
  if (filters.perPage) params.per_page = filters.perPage;

  const response = await api.get('/api/v1/admin/user-activity-logs', { params });
  const data = response?.data?.data || response?.data || {};

  return {
    logs: data.logs || [],
    total: data.total || 0,
    currentPage: data.current_page || 1,
    lastPage: data.last_page || 1,
    categoryCounts: data.category_counts || null,
  };
}

// ---------------------------------------------------------------------------
// Export filtered logs as downloadable PDF (server-generated)
// ---------------------------------------------------------------------------
export async function exportPdf(filters = {}) {
  const params = {};
  if (filters.dateFrom) params.date_from = filters.dateFrom;
  if (filters.dateTo) params.date_to = filters.dateTo;
  if (filters.actionType && filters.actionType.length) params.action_type = filters.actionType.join(',');
  if (filters.search) params.search = filters.search;

  const response = await api.get('/api/v1/admin/user-activity-logs/export-pdf', {
    params,
    responseType: 'blob',
  });

  const disposition = response.headers?.['content-disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/i);
  const filename = match
    ? match[1]
    : `sulhafa-user-activity-log-${new Date().toISOString().split('T')[0]}.pdf`;

  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
  return { success: true };
}
